var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-35",
    "data-name": "50_Kids_Icons-35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#9ec853"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4683",
    "data-name": "Group 4683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4640",
    "data-name": "Group 4640",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M161.313,251.313H116L119.356,206h36.921Z",
    transform: "translate(-97.875 -173.813)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M384.38,378.154l-4.939.011-2.429,18.527,12.342-2.673Z",
    transform: "translate(-318.104 -319.067)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4649",
    "data-name": "Group 4649",
    transform: "translate(42.55 14.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 3.898,
    cy: 4.548,
    rx: 3.898,
    ry: 4.548,
    transform: "translate(2.943 3.537) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 3.898,
    cy: 4.548,
    rx: 3.898,
    ry: 4.548,
    transform: "translate(0 7.304) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4642",
    "data-name": "Group 4642",
    transform: "translate(5.131 5.041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 3.76,
    cy: 4.387,
    rx: 3.76,
    ry: 4.387,
    transform: "translate(2.838 3.412) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 3.76,
    cy: 4.387,
    rx: 3.76,
    ry: 4.387,
    transform: "translate(0 7.045) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4643",
    "data-name": "Group 4643",
    transform: "translate(8.884 11.566)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 3.622,
    cy: 4.226,
    rx: 3.622,
    ry: 4.226,
    transform: "translate(2.734 3.286) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 3.622,
    cy: 4.226,
    rx: 3.622,
    ry: 4.226,
    transform: "translate(0 6.786) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4644",
    "data-name": "Group 4644",
    transform: "translate(11.486 18.769)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 3.484,
    cy: 4.064,
    rx: 3.484,
    ry: 4.064,
    transform: "translate(2.63 3.161) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 3.484,
    cy: 4.064,
    rx: 3.484,
    ry: 4.064,
    transform: "translate(0 6.527) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4645",
    "data-name": "Group 4645",
    transform: "translate(13.167 25.839)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 3.346,
    cy: 3.903,
    rx: 3.346,
    ry: 3.903,
    transform: "translate(2.525 3.036) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 3.346,
    cy: 3.903,
    rx: 3.346,
    ry: 3.903,
    transform: "translate(0 6.268) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4646",
    "data-name": "Group 4646",
    transform: "translate(14.155 31.968)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 3.207,
    cy: 3.742,
    rx: 3.207,
    ry: 3.742,
    transform: "translate(2.421 2.91) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 3.207,
    cy: 3.742,
    rx: 3.207,
    ry: 3.742,
    transform: "translate(0 6.009) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4647",
    "data-name": "Group 4647",
    transform: "translate(14.679 36.348)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 3.069,
    cy: 3.581,
    rx: 3.069,
    ry: 3.581,
    transform: "translate(2.317 2.785) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 3.069,
    cy: 3.581,
    rx: 3.069,
    ry: 3.581,
    transform: "translate(0 5.75) rotate(-26.983)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4648",
    "data-name": "Group 4648",
    transform: "translate(14.969 38.169)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 2.931,
    cy: 3.42,
    rx: 2.931,
    ry: 3.42,
    transform: "translate(2.213 2.66) rotate(-26.983)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 2.931,
    cy: 3.42,
    rx: 2.931,
    ry: 3.42,
    transform: "translate(0 5.491) rotate(-26.983)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M75.765,379.216l4.935-.2,3.234,18.4-12.447-2.133Z",
    transform: "translate(-60.317 -319.791)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659",
    transform: "translate(13.229 14.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4651",
    "data-name": "Group 4651",
    transform: "translate(10.33)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 4.548,
    cy: 3.898,
    rx: 4.548,
    ry: 3.898,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 8.278)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 4.548,
    cy: 3.898,
    rx: 4.548,
    ry: 3.898,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 3.104, 11.913)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4652",
    "data-name": "Group 4652",
    transform: "translate(5.906 5.244)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 4.387,
    cy: 3.76,
    rx: 4.387,
    ry: 3.76,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 7.985)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 4.387,
    cy: 3.76,
    rx: 4.387,
    ry: 3.76,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.994, 11.491)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4653",
    "data-name": "Group 4653",
    transform: "translate(2.926 11.913)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 4.226,
    cy: 3.622,
    rx: 4.226,
    ry: 3.622,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 7.691)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 4.226,
    cy: 3.622,
    rx: 4.226,
    ry: 3.622,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.884, 11.069)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4654",
    "data-name": "Group 4654",
    transform: "translate(1.124 19.207)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 4.064,
    cy: 3.484,
    rx: 4.064,
    ry: 3.484,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 7.398)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 4.064,
    cy: 3.484,
    rx: 4.064,
    ry: 3.484,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.774, 10.646)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4655",
    "data-name": "Group 4655",
    transform: "translate(0.236 26.329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 3.903,
    cy: 3.346,
    rx: 3.903,
    ry: 3.346,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 7.104)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 3.903,
    cy: 3.346,
    rx: 3.903,
    ry: 3.346,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.664, 10.224)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4656",
    "data-name": "Group 4656",
    transform: "translate(0 32.48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 3.742,
    cy: 3.207,
    rx: 3.742,
    ry: 3.207,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 6.811)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 3.742,
    cy: 3.207,
    rx: 3.742,
    ry: 3.207,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.554, 9.802)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657",
    transform: "translate(0.151 36.864)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 3.581,
    cy: 3.069,
    rx: 3.581,
    ry: 3.069,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 6.518)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 3.581,
    cy: 3.069,
    rx: 3.581,
    ry: 3.069,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.444, 9.38)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4658",
    "data-name": "Group 4658",
    transform: "translate(0.425 38.681)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 3.42,
    cy: 2.931,
    rx: 3.42,
    ry: 2.931,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 0, 6.224)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 3.42,
    cy: 2.931,
    rx: 3.42,
    ry: 2.931,
    transform: "matrix(0.414, -0.91, 0.91, 0.414, 2.334, 8.957)",
    fill: "#3d2a3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4661",
    "data-name": "Group 4661",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M146.595,217.31c1.125,2.664.512,5.254-1.368,5.784s-4.317-1.2-5.442-3.864-.512-5.254,1.368-5.784S145.47,214.646,146.595,217.31Z",
    transform: "translate(-117.468 -180.015)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M329.931,217.31c-1.125,2.664-.512,5.254,1.368,5.784s4.317-1.2,5.441-3.864.513-5.254-1.368-5.784S331.056,214.646,329.931,217.31Z",
    transform: "translate(-277.904 -180.014)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4662",
    "data-name": "Group 4662",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M119.654,399.234l-.009-.144c0-8.781-3.287-17.288-7.3-18.908L95.252,373.3a22.645,22.645,0,0,0-14.6-.019L63.313,380.2c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144Z",
    transform: "translate(-47.25 -313.94)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4663",
    "data-name": "Group 4663",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M227.843,250.8a6.825,6.825,0,0,1-6.825,6.825h-.828a6.825,6.825,0,0,1-6.825-6.825V233.22a6.825,6.825,0,0,1,6.825-6.825h.828a6.825,6.825,0,0,1,6.825,6.825Z",
    transform: "translate(-180.028 -191.021)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664",
    "data-name": "Group 4664",
    transform: "translate(25.889 11.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M195.067,100.877a14.688,14.688,0,0,1-14.688,14.688h0a14.688,14.688,0,0,1-14.688-14.688V88.66a14.688,14.688,0,0,1,14.688-14.688h0A14.688,14.688,0,0,1,195.067,88.66v12.217Z",
    transform: "translate(-165.691 -73.972)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4666",
    "data-name": "Group 4666",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(33.247 35.598)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 1.698,
    cy: 1.698,
    r: 1.698,
    transform: "translate(44.51 35.598)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M166.584,69.792c-9.523,0-17.242,8.367-17.242,18.689a19.809,19.809,0,0,0,2.338,9.4l.565-4.794a11.025,11.025,0,0,1,10.949-9.734h6.778a11.025,11.025,0,0,1,10.95,9.732l.567,4.8a19.81,19.81,0,0,0,2.338-9.4C183.827,78.159,176.107,69.792,166.584,69.792Z",
    transform: "translate(-126.007 -58.887)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M247,253.581a2.616,2.616,0,0,1-5.106.591,2.768,2.768,0,0,0-.125.78,2.8,2.8,0,1,0,5.6,0A2.765,2.765,0,0,0,247,253.581Z",
    transform: "translate(-203.989 -213.959)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4669",
    "data-name": "Group 4669",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M119.645,413.291c0-8.781-3.287-17.288-7.3-18.908l-13.591-5.475a12,12,0,0,1-21.828.058L63.313,394.4c-4.017,1.608-7.3,10.106-7.3,18.886l-.009.144h63.654Z",
    transform: "translate(-47.25 -328.141)",
    fill: "#966796"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4670",
    "data-name": "Group 4670",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 3.43,
    cy: 2.572,
    rx: 3.43,
    ry: 2.572,
    transform: "translate(46.579 38.995)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 3.43,
    cy: 2.572,
    rx: 3.43,
    ry: 2.572,
    transform: "translate(27.716 38.995)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4671",
    "data-name": "Group 4671",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M232.218,287.411a5.359,5.359,0,0,1-7.119,0c-1.351-1.272-3.392.761-2.037,2.037a8.3,8.3,0,0,0,11.193,0c1.355-1.276-.686-3.309-2.037-2.037Z",
    transform: "translate(-187.832 -242.163)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4674",
    "data-name": "Group 4674",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672",
    transform: "translate(31.697 32.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M203.709,208.108a4.644,4.644,0,0,1,3.443-1.435.5.5,0,0,0,0-1.005A5.654,5.654,0,0,0,203,207.4c-.435.479.274,1.192.711.711Z",
    transform: "translate(-202.862 -205.668)",
    fill: "#735a73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4673",
    "data-name": "Group 4673",
    transform: "translate(44.069 32.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M286.683,207.4a5.653,5.653,0,0,0-4.154-1.729.5.5,0,0,0,0,1.005,4.643,4.643,0,0,1,3.443,1.435c.437.481,1.146-.233.711-.711Z",
    transform: "translate(-282.044 -205.669)",
    fill: "#735a73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4682",
    "data-name": "Group 4682",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4675",
    "data-name": "Group 4675",
    transform: "translate(31.207 10.43)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 2.96,
    cy: 3.453,
    rx: 2.96,
    ry: 3.453,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.789)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 2.96,
    cy: 3.453,
    rx: 2.96,
    ry: 3.453,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.739, 5.408)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4676",
    "data-name": "Group 4676",
    transform: "translate(32.676 15.122)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 2.855,
    cy: 3.331,
    rx: 2.855,
    ry: 3.331,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.513)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 2.855,
    cy: 3.331,
    rx: 2.855,
    ry: 3.331,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.642, 5.216)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4677",
    "data-name": "Group 4677",
    transform: "translate(36.049 19.065)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 2.75,
    cy: 3.208,
    rx: 2.75,
    ry: 3.208,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 7.236)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 2.75,
    cy: 3.208,
    rx: 2.75,
    ry: 3.208,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.545, 5.025)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4678",
    "data-name": "Group 4678",
    transform: "translate(40.73 22.053)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 2.645,
    cy: 3.086,
    rx: 2.645,
    ry: 3.086,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.96)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 2.645,
    cy: 3.086,
    rx: 2.645,
    ry: 3.086,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.448, 4.833)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4679",
    "data-name": "Group 4679",
    transform: "translate(46.126 23.881)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 2.54,
    cy: 2.963,
    rx: 2.54,
    ry: 2.963,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.684)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 2.54,
    cy: 2.963,
    rx: 2.54,
    ry: 2.963,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.351, 4.641)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680",
    transform: "translate(51.64 24.342)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 2.435,
    cy: 2.841,
    rx: 2.435,
    ry: 2.841,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 6.409)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 2.435,
    cy: 2.841,
    rx: 2.435,
    ry: 2.841,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 2.254, 4.45)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4681",
    "data-name": "Group 4681",
    transform: "translate(56.678 25.105)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 2.33,
    cy: 2.719,
    rx: 2.33,
    ry: 2.719,
    transform: "matrix(0.407, -0.914, 0.914, 0.407, 0, 4.258)",
    fill: "#3d2a3d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar20);
export default __webpack_public_path__ + "static/media/avatar20.29c9a366ff7071be235f42213340f8f5.svg";
export { ForwardRef as ReactComponent };